import type { ISpread } from "../../spreadsSlice";

export const twoCardsSpread: ISpread = {
  id: "spread_two_cards",
  name: "Две карты",
  altNames: ["Two-Card Spread"],
  purpose:
    "Прояснение динамики между двумя энергиями, диагностика их взаимодействия и понимание того, как одна энергия приводит к другой.",
  cardsCount: 2,
  layout: "[1]   [2]",
  positions: [
    {
      id: "influence",
      title: "Главное влияние / текущая энергия",
      meaning: "То, что определяет ситуацию.",
    },
    {
      id: "reaction",
      title: "Ответная реакция / результат",
      meaning: "То, что вытекает из первой энергии.",
    },
  ],
  symbolism:
    "Две карты символизируют дуальность: активное и пассивное, инь и ян, взаимодействие сил.",
  archetypes: ["Двойственность", "Полярность", "Партнёрство"],
  psychology:
    "Помогает увидеть, как одно состояние рождает другое, выявить напряжение или гармонию между аспектами ситуации и осознать скрытые мотивы.",
  procedure: {
    preparation:
      "Сформулировать вопрос о взаимодействии двух энергий или сторон ситуации.",
    steps:
      "Перетасовать колоду; выложить две карты слева направо; прочитать первую как определяющее влияние, вторую — как ответную реакцию или результат; затем проанализировать их взаимодействие.",
  },
  interpretations: [
    "9 Мечей → 4 Мечей: тревога сменяется вынужденной паузой",
    "Колесница → Справедливость: решительность приводит к сбалансированному решению",
  ],
  nuances: [
    "До выкладки важно заранее определить значения позиций и не менять их после получения карт.",
    "Карты следует читать как процесс и взаимодействие, а не как два изолированных состояния.",
    "SOURCE также допускает варианты: «вы → другой человек», «сознательное → бессознательное» и «причина → следствие». В текущей реализации используется основной вариант «влияние → реакция / результат».",
  ],
  examples: [
    {
      cards: ["9 Мечей", "4 Мечей"],
      interpretation: "Тревога → остановка для восстановления",
    },
    {
      cards: ["Колесница", "Справедливость"],
      interpretation: "Активное действие → взвешенное решение",
    },
  ],
  selfQuestions: [
    "Какие две основные энергии действуют сейчас?",
    "Какая связь между ними?",
    "Как я могу гармонизировать их взаимодействие?",
  ],
};

